import axios, { AxiosResponse } from 'axios';
import authHeader from './auth-header';
import Cookies from 'universal-cookie';
import { CbSignUpType, CbTagCreateType, JoinType, JwtToken, LoginType } from '../types/user.type';
import { PagingType, CustomResponse, PagingMessageType, memoSettingType, userMemoSettingType, tagDeleteAllType, tagAddAllType } from '../components/layout/common.type';
import {API_BASE_URL_ISSUER, AUTH_API_URLS,API_BASE_URL }from './apiConfig';
import { MainCommentParmTypes } from '../types/board.type';
const AUTH_API_URL = AUTH_API_URLS; //오라클
const CH_API_URL = API_BASE_URL;
const DID_API_URL = API_BASE_URL;
const ISSUER_API_URL = API_BASE_URL_ISSUER;
// const SOCIAL_API_URL = 'https://develop.snubi.org:19106/';
const cookie = new Cookies();
let isTokenRefreshing = false;
let isMultipart = false;

const client = axios.create({
    baseURL: '',
    timeout: 15000,
});                                                             

client.interceptors.request.use(async (config) => {
    try{        
       const ACCESS_TOKEN = localStorage.getItem("tokenOrigin");   
       if(isMultipart)
            config.headers['Content-Type'] = 'multipart/form-data';
        else
            config.headers['Content-Type'] = 'application/json';

       if(ACCESS_TOKEN != null)
         config.headers['Authorization'] = `Bearer ${ACCESS_TOKEN}`;
        
        isMultipart = false;
    }
    catch(e)
    {
        alert('Error request' + e);        
    }
    return config;
});

client.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const {
        config,
        response: { status },
      } = error;  
      const originalRequest = config;  
      console.log("status", status);
      console.log();
      if (status === 401) {
        if (!isTokenRefreshing) {    
            if(error.response.data.code === '4401'){
                window.location.href= '/signin'; 
            }
            if(error.response.data.code === '4402'){
                isTokenRefreshing = true;
                const REFRESH_TOKEN = cookie.get('refresh-token');
                axios({
                    method: 'post',
                    url: `${AUTH_API_URL}/api/auth/refresh`,
                    data: { REFRESH_TOKEN },
                }).then((response) => {
                    const accessToken = response.data.data.accessToken;
                    isTokenRefreshing = false;
                    cookie.set('access_token', accessToken);
                    client.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
                    client.defaults.headers.common['Content-Type'] = 'application/json';
                    return axios(originalRequest);
                });
            }   
        }        
      }
      return Promise.reject(error);
    },
  );

const responseBody = (response: AxiosResponse) => response.data;
const requests = {
    get:    (url: string)           => client.get(url).then(responseBody),
    post:   (url: string, body: {}) => client.post(url, body).then(responseBody),
    put:    (url: string, body: {}) => client.put(url, body).then(responseBody),
    patch:    (url: string, body: {}) => client.patch(url, body).then(responseBody),
    delete: (url: string)           => client.delete(url).then(responseBody),
    file:   (url: string, body: {}) => 
        axios({
            method: "post",
            url: url,
            data: body,
            headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${localStorage.getItem("tokenOrigin")}` }
          }).then(responseBody),
    
};

export const CustomAxios = {
    postLogin: (post:LoginType): Promise<CustomResponse> => requests.post(AUTH_API_URL +'login',post),

    postSignUp: (post:CbSignUpType): Promise<CustomResponse> => requests.post(CH_API_URL +'/agency/signup',post),

    postSignUpUserJwt: (post:CbSignUpType): Promise<CustomResponse> => requests.post(CH_API_URL +'/brain/user/signup',post),

    postTagCreate: (post:CbTagCreateType): Promise<CustomResponse> => requests.post(CH_API_URL +'/brain/study/condition/tag/create',post),
    postStudyCreateFile: (post:FormData): Promise<CustomResponse> => requests.file(CH_API_URL +'/brain/study/create/file',post),
    
    getAccount: (): Promise<CustomResponse> => requests.get(CH_API_URL + '/account'),
    patchTagMemoDeleteAll: (patch:tagDeleteAllType): Promise<CustomResponse> => requests.patch(ISSUER_API_URL +'/filters/delete/all/memo/data',patch),  

    // getConditionTagListAll: (): Promise<CustomResponse> => requests.get(CH_API_URL + `/brain/study/taglist?sort=conditionTagId,desc`),
    // getAnalysisTypeListAll: (): Promise<CustomResponse> => requests.get(CH_API_URL + `/brain/study/analysis/typelist?sort=analysisTypeId,desc`),
    // getConditionTag:(id:number) : Promise<CustomResponse> => requests.get(CH_API_URL + `/brain/study/tag/${id}`),
    // getAnalysisTypeTag:(id:number) : Promise<CustomResponse> => requests.get(CH_API_URL + `/brain/study/analysis/type/${id}`),


    getClubOne: (clubSeq:number): Promise<CustomResponse> => requests.get(DID_API_URL +  `/club/list/one/web/${clubSeq}`),  

    postPersonalMessageCreate: (post: FormData): Promise<CustomResponse> => {const token = localStorage.getItem("tokenOrigin"); if (token !== null) {post.append('token', token); }return requests.file(DID_API_URL + '/club/personal/message/create', post); },
    postPersonalMessageCreateScheduler: (post: FormData): Promise<CustomResponse> => {const token = localStorage.getItem("tokenOrigin"); if (token !== null) {post.append('token', token); }return requests.file(DID_API_URL + '/club/personal/message/create/scheduler', post); },

    getMemberList: (parm:PagingType): Promise<CustomResponse> => requests.get(ISSUER_API_URL +`/filters/members?page=${parm.page}&size=${parm.size}&diagnosisPeriod=${parm.searchDiagnosisPeirod}&localName=${parm.localName}&room=${parm.room}&symptom=${parm.symptom}&memoData=${parm.memoData}&memberName=${parm.memberName}&diagnosisDate=${parm.diagnosisDate}&mobileNumber=${parm.mobileNumber}&extraData=${parm.extraData}&clubSeq=${parm.clubSeq}`),
    getClubInfos: (agentSeq:number,clubSeq:number): Promise<CustomResponse> => requests.get(ISSUER_API_URL +  `/filters/club/infos?agentSeq=${agentSeq}&clubSeq=${clubSeq}`),  
        patchTagMemoAddAll: (patch:tagAddAllType): Promise<CustomResponse> => requests.patch(ISSUER_API_URL +'/filters/add/all/memo/data',patch),  

        patchMemoSetting: (patch:memoSettingType): Promise<CustomResponse> => requests.patch(ISSUER_API_URL +'/filters/memo/settings',patch),   
        
        patchUserMemoSetting: (patch:userMemoSettingType): Promise<CustomResponse> => requests.patch(ISSUER_API_URL +'f/ilters/memo/data',patch),  



        // getMessageList: (parm:PagingMessageType): Promise<CustomResponse> => requests.get(DID_API_URL + 
        // `/club/personal/message/list/${parm.clubSeq}/${parm.memberId}?page=${parm.page}&size=${parm.size}&sort=personalMessageSeq,desc`),
        // @RequestMapping(value = "/club/personal/message/issuer/list/{clubSeq}", method = RequestMethod.GET)

        getMessageList: (parm:PagingMessageType): Promise<CustomResponse> => requests.get(DID_API_URL + 
            `/club/personal/message/issuer/list/${parm.clubSeq}?page=${parm.page}&size=${parm.size}&sort=personalMessageSeq,desc`),
};
